import styled from "styled-components";

export const Container = styled.main`
  section{
    margin: 0 auto;
    padding: 40px;
    border: 1px solid var(--gray_c);
    border-radius: 24px;
    + section{
      margin-top: 60px;
    }

    .section_title{
      margin-bottom: 36px;
      span{
        display: inline-block;
        padding-bottom: 6px;
        border-bottom: 1px solid var(--main);
        font-size: 16px;
      }
    }

    .row{
      display: flex;
      align-items: center;
      justify-content: space-between;
      + .row{
        margin-top: 24px;
      }

      .form_label_row{
        min-width: 60px;
      }

      &.coupon{
        align-items: flex-start;
        .form_label_row{
          height: 40px;
          line-height: 40px;
        }
        .row_right{
          .used_msg{
            margin: 6px 0 0;
            text-align: right;
          }
        }
        .coupon_input_bx{
          position: relative;
          .text_field_view{
            width: 240px;
          }
          input{
            height: 40px;
          }
          button{
            width: 50px;
            height: 100%;
            border-radius: 0 6px 6px 0;
            position: absolute;
            top: 0;
            right: 0;
          }
        }
        .cuopon_bx{
          height: 40px;
          border: 1px solid var(--gray_c);
          border-radius: 6px;
          display: flex;
          p{
            height: 100%;
            padding: 0 12px;
            display: flex;
            align-items: center;

            &:nth-child(2){
              border-left: 1px dashed var(--gray_c);
              position: relative;

              &::before, &::after{
                content: '';
                width: 8px;
                height: 4px;
                border: 1px solid var(--gray_c);
                background-color: #fff;
                position: absolute;
                left: 0;
                z-index: 2;
              }

              &::before{
                border-top: none;
                border-radius: 0 0 8px 8px;
                top: 0;
                transform: translate(-50%, -1px);
              }
              &::after{
                border-bottom: none;
                border-radius: 8px 8px 0 0;
                bottom: 0;
                transform: translate(-50%, 1px);
              }
            }
          }

          &.used{
            border-color: var(--gray_e);
            background-color: var(--gray_e);
            p{
              color: var(--gray_9a);
              &:nth-child(2){
                &::before, &::after{
                  border-color: var(--gray_e);
                }
              }
            }
          }
        }
      }
    }

    button{
      &.outlined_gray{
        height: 40px;
        padding: 0 24px;
        border-radius: 6px;
        &:hover{
          color: #148655;
        }
      }
      &.btn_withdrawal, &.btn_change, &.btn_subscription_cancel, &.btn_payment_info{
        padding: 6px 12px;
        border: none;
        background-color: transparent;
        transition: all .25s;
        &:hover{
          text-decoration: underline;
        }

        .ic{
          width: 12px;
          height: 12px;
          margin-left: 6px;
          background-color: #555;
          mask: url(/images/arrow.png) no-repeat center center / cover;
        }
      }

      &.btn_withdrawal{
        margin: 24px -12px 0 auto;
      }
      &.btn_change{
        margin: 12px -12px 0 auto;
      }
    }

    &.subscribe{
      .section_title{
        &:not(.flex){
          .subscribe_status{
            margin: 6px 0 0;
          }
        }
        .contained_red{
          height: 30px;
          margin: 0 0 0 12px;
          padding: 0px 12px;
          border-radius: 6px;
        }
      }
      .group_btn{
        margin: 24px -12px 0 0;
        justify-content: flex-end;
        button + button{
          margin: 0 0 0 12px;
        }
      }
    }
  }

  @media screen and (min-width: 501px){
    section{
      width: 600px;
      .row{
        p{
          &.form_label_row{
            width: 96px;
            min-width: 96px;
          }
          &:not(.form_label_row){
            font-size: 16px;
          }
        }
      }
    }
  }

  @media (max-width: 500px) {
    section{
      width: 100%;

      &.subscribe{
        .row{
          flex-direction: column;
          align-items: flex-start;

          p{
            &.form_label_row{
              margin-bottom: 6px;
            }
            &:not(.form_label_row){
              font-size: 14px;
            }
          }
        }
      }

    }
  }
`